import 'client-only'

import { YANDEX_CAPTCHA_CLIENT_STAGING } from '@/config/captcha.keys'

/** Публичные ключи капчи. Yandex sitekey на проде берётся из runtime-инъекции, не из bake-time NEXT_PUBLIC_. */
export const SETTINGS_CLIENT = {
    YANDEX_CAPTCHA_CLIENT:
        process.env.NEXT_PUBLIC_CAPTCHA_CLIENT_KEY ??
        YANDEX_CAPTCHA_CLIENT_STAGING,
    TURNSTILE_SITE_KEY: process.env.NEXT_PUBLIC_TURNSTILE_SITE_KEY ?? '',
    CAPTCHA_PROVIDER:
        (process.env.NEXT_PUBLIC_CAPTCHA_PROVIDER as
            | 'yandex'
            | 'turnstile'
            | undefined) ?? 'yandex',
}
